import { IWatrReimbursement, IWatrRequestAuditLog, IWatrLimit } from ".";
import { IWatrMileageTripDetail } from ".";
import { IWatrRequestWeeks } from ".";
import { IWatrRequestTravels } from ".";
import { IPaystub } from ".";
import { State, WatrToDoType } from '../enums';
import { IDonorShieldDirect, IWatrPaymentError } from '@nkr/models/index';
import { IWatrFraudFlag } from "./watr-fraud-flag";

export interface IFileUploadRecord {
    id: number;
    fileName: string;
    fileType: number;
    fileTypeDescription: string;
    uploadedDateTime: string;
    isActive: boolean;
}

export interface IWatrRequest {
    id: number,
    editKey?: string,
    donationType: number,
    donationTypeDesc: string,
    donationOrganType: number,
    watrRequestType: number,
    watrRequestTypeDesc: string,
    name: string,
    firstName: string,
    middleInitial?: string,
    lastName: string,
    email: string,
    achAccountNumber: string,
    achRoutingNumber: string,
    intBankingNumber: string,
    intSwiftNumber: string,
    bankInfo?: string,
    mobile: string,
    alias: string,
    birthDate: string,
    donationDate: Date,
    expirationDate: string,
    country: number,
    countryName: string,
    countryOfCitizenship: number,
    countryOfCitizenshipName: string,
    donationConfirmed: boolean,
    hasTravelReceipt: boolean,
    totalWagesReimbursedDays: number,
    wagesReimbursed: number,
    dashboardLink: string,
    additionalDaysRequested: number,
    canRequestAdditionalLwrDays: boolean,
    status: number,
    statusDescription: string,
    pendingLWRVerify: boolean,
    pendingDERVerify: boolean,
    pendingLWRPayment: boolean,
    pendingDERPayment: boolean,
    lwr: number,
    tlr: number,
    toBeVerifiedTLR: number;
    derReimbursedStandard?: number;
    derReimbursedWorkup?: number;
    derProgramCap?: number;
    arWorkupVisitCap?: number | null;
    arPreOpVisitCap?: number | null;
    arInternationalWorkupVisitCap?: number | null;
    createdDate: string,
    calculatedWeeklyPayByYear: number,
    ssnDecrypted: string,
    incomeIrsYear: number,
    incomeIrsYearGross: number,
    calculatedWeeklyPayByPayStub: number,
    incomePayStubStartDate: string,
    incomePayStubEndDate: string,
    estWorkDays: number,
    calculatedBusinessDaysInPayStub: number,
    incomePayStubGross: number,
    estimatedWageReimbursementAmount: number,
    actualWageReimbursementAmount: number,
    wageReimbursementAmount: number,
    isApprovalRecommended: boolean,
    hasBeenReimbursed: boolean,
    hasBeenTravelReimbursed: boolean,
    roundTripMiles: number,
    requestWeeks: IWatrRequestWeeks[],
    requestTravels: IWatrRequestTravels[],
    roundTripInstances: IWatrMileageTripDetail[],
    reimbursementRate: number,
    reimbursementAmount: number,
    hotelLodgingExpense: number,
    flightAndTrainExpense: number,
    carServiceExpense: number,
    dependentCareExpense: number,
    mealExpense: number,
    dependentCareFile: boolean,
    dependentCompanionFile: boolean,
    paymentAssistanceFile: boolean,
    selfEmployedAffirmationFile: boolean,
    requireSelfEmployedAffirmation: boolean,
    travelReceiptsFile: boolean,
    payStubFile: boolean,
    taxDocumentFile: boolean,
    travelReceiptsTotal: number,
    travelReimbursementTotal: number,
    centerId: number,
    centerAlias: string,
    centerLatitude: number,
    centerLongitude: number,
    donorShieldId: number,
    donorId: number,
    donorAlias: string,
    addressLine1: string,
    addressLine2?: string,
    city: string,
    state: State,
    stateAbbr: string,
    province: string,
    postalCode: string,
    incomePercentCovered: number,
    additionalDetails: string,
    logs: IWatrRequestAuditLog[],
    dsdRecord: IDonorShieldDirect,
    afterDonationDate: boolean,
    hasComplications: boolean,
    hasActiveComplicationsReport?: boolean,
    mobilePhone: string,
    birthdate: string,
    toDoType: WatrToDoType,
    totalWagesReimbursed: number,

    otherRequests: IWatrRequest[]
    limit: IWatrLimit
    paymentErrors: IWatrPaymentError[],
    fraudFlags: IWatrFraudFlag[],
    achReimbursementType?: number,
    transactionAmount?: number,
    pendingTransactionConfirmation?: string,
    pendingTransactionAmount?: number,
    pendingTransactionSendOn?: string,
    reimbursements: IWatrReimbursement[],
    requestTravel: IWatrRequestTravels[],
    allowSixtyDayOverride: boolean,
    sixtyDayOverride: boolean,
    allowNinetyDayLWROverride: boolean,
    ninetyDayLWROverride: boolean,
    expenseLimitOverride: boolean,

    isUsBank?: boolean | null,
    bankCountry?: number | null,
    bankCountryName?: string | null,
    filesTaxesInUs?: boolean | null,
    isInternationallyEligible?: boolean | null,

    bankInformation: IBankInformation,
    employmentType?: string | number,
    paystubs?: IPaystub[],

    bankingRoutingRequiresReview?: boolean,
    bankingAccountRequiresReview?: boolean,

    advancedProgress?: IAdvancedProgress,

    fileUploadRecords?: IFileUploadRecord[],
}

export interface IBankInformation {
    nameOfBank: string,
    cityTownLocality: string,
    stateProvinceRegion: string,
    postalCode: string,
    additionalCode: string
}

export interface IAdvancedProgress {
    invited?: boolean,
    profileComplete?: boolean,
    applicationConfirmed?: boolean,
    requestSubmitted?: boolean,
    nkrReviewed?: boolean,
    status?: string,
    statusCode?: number,
    lastMilestoneDate?: string,
    workupScheduledDate?: string,
    canDonorConfirmApplication?: boolean,
    invitePending?: boolean,
    onTrack?: boolean,
}